// import React, { useEffect } from "react";

// const Facebook = () => {
//   useEffect(() => {
//     // @ts-ignore
//     !(function (f, b, e, v, n, t, s) {
//       // @ts-ignore
//       if (f.fbq) return;
//     // @ts-ignore
//       n = f.fbq = function () {
//       // @ts-ignore
//         n.callMethod
//         // @ts-ignore
//           ? n.callMethod.apply(n, arguments)
//           // @ts-ignore
//           : n.queue.push(arguments);
//       };
//       // @ts-ignore
//       if (!f._fbq) f._fbq = n;
//       // @ts-ignore
//       n.push = n;
//       // @ts-ignore
//       n.loaded = !0;
//       // @ts-ignore
//       n.version = "2.0";
//       // @ts-ignore
//       n.queue = [];
//       // @ts-ignore
//       t = b.createElement(e);
//       // @ts-ignore
//       t.async = !0;
//       // @ts-ignore
//       t.src = v;
//       // @ts-ignore
//       s = b.getElementsByTagName(e)[0];
//       // @ts-ignore
//       s.parentNode.insertBefore(t, s);
//     })(
//       window,
//       document,
//       "script",
//       "https://connect.facebook.net/en_US/fbevents.js"
//     );
//     // @ts-ignore
// 		fbq('init', '791178399319087');
// 		// @ts-ignore
// 		fbq('track', 'PageView');
// 			}, []);

//   return null;
// };

// export default Facebook;




import React from "react";
import { Helmet } from "react-helmet";

const MetaPixel = () => {
	return (
		<Helmet>
			<script id="facebook-pixel-script">
				{`
         
					!function (f, b, e, v, n, t, s) {
           
						if (f.fbq) return; n = f.fbq = function () {
             
							n.callMethod ?
               
								n.callMethod.apply(n, arguments) : n.queue.push(arguments)
						};
          
						if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
           
						n.queue = []; t = b.createElement(e); t.async = !0;
           
						t.src = v; s = b.getElementsByTagName(e)[0];
           
						s.parentNode.insertBefore(t, s)
           
					}(window, document, 'script',
         
						'https://connect.facebook.net/en_US/fbevents.js');
           
				fbq('init', '791178399319087');
       
				fbq('track', 'PageView');
     
			`}
			</script>
			<noscript id="facebook-pixel-image">
				{`
					<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=791178399319087&ev=PageView&noscript=1"/>
          `}</noscript>
		</Helmet>
	);
};

export default MetaPixel;